import { render, staticRenderFns } from "./CartItemView.vue?vue&type=template&id=2629a498"
import script from "./CartItemView.vue?vue&type=script&lang=ts"
export * from "./CartItemView.vue?vue&type=script&lang=ts"
import style0 from "./CartItemView.vue?vue&type=style&index=0&id=2629a498&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports